module.exports = __webpack_public_path__ + "img/p6-pic.f07ad1cd.jpg";